import React from 'react';
import PropTypes from 'prop-types';

const ColumnLayout = function (props) {
  return (
    <div className={props.customizeStyle}>
      <div className="col-sm-12 col-md-6 col-lg-6 contact-left-container">{props.leftPanel}</div>
      <div className="col-sm-12 col-md-6 col-lg-6 contact-right-container">{props.rightPanel}</div>
    </div>
  );
};

ColumnLayout.propTypes = {
  leftPanel: PropTypes.element.isRequired,
  rightPanel: PropTypes.element,
  customizeStyle: PropTypes.string,
};

ColumnLayout.defaultProps = {
  customizeStyle: 'contact-service-container',
  rightPanel: '',
};

export default ColumnLayout;
